<template>
    <div class="footer">
      <p class="m-0">© Donamaid.com - 2021 - <a href="https://donamaid.com/termos-de-uso" target="_blank" >Termos de uso</a>.</p>
    </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  position: relative;
  left: 0;
  width: 100%;
  height: 45px;
  background: var(--purple);
  font-size: 14px;
  line-height: 45px;
  text-align: center;
  color: #ffffff;
}

a {
  color: #45e9df;
  text-decoration: none;
}
a:hover {
  border-bottom: 1px dotted #45e9df;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue